import { render, staticRenderFns } from "./customformmain.vue?vue&type=template&id=36687c5a&"
import script from "./customformmain.vue?vue&type=script&lang=js&"
export * from "./customformmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports